export default __webpack_public_path__ + "static/media/search-icon.5ca76ea3.svg";